<template>
  <div>
    <form @submit.prevent="submitReset">
      <div class="form-group row">
        <div class="col-12 col-md-8">
          <label class="col-form-label"
            >Please enter your email address.
          </label>
        </div>
        <div class="col-12">
          <input
            v-model="form.useremail"
            type="email"
            class="form-control"
            :class="{
              'is-invalid': formsubmit && $v.form.useremail.$error,
            }"
          />
          <div
            v-if="formsubmit && $v.form.useremail.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.useremail.required"
              >Email address is required.</span
            >
            <span v-else-if="!$v.form.useremail.email"
              >Email address is invalid.</span
            >
          </div>
        </div>
      </div>

      <div class="form-group row text-right mt-2">
        <div class="col-8 offset-4">
          <b-btn variant="danger" @click="submitReset">Reset Password</b-btn>
          <b-btn
            variant="secondary"
            class="m-l-5 ml-1"
            @click="$bvModal.hide('forgot-password')"
            >Cancel</b-btn
          >
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import { reqPasswordReset } from '@services'

export default {
  data() {
    return {
      formsubmit: false,

      form: {
        useremail: '',
      },
    }
  },

  validations: {
    form: {
      useremail: {
        required,
        email,
      },
    },
  },

  methods: {
    async submitReset(e) {
      this.formsubmit = true
      this.$v.$touch()

      if (!this.$v.$invalid) {
        const result = await reqPasswordReset({
          username: this.form.useremail,
        })
        this.$swal({
          title: result.status,
          text: result.message,
          icon:result.status.toLowerCase(),
        })

        if (result.status === 'Success') {
          this.$bvModal.hide('forgot-password')
          this.$emit("passwordResetCompleted")
        }
      }
    },
  },
}
</script>
